export default __webpack_public_path__ + "static/media/028-radish.51b45385.svg";